// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"b6e4cb12","171":"c5d6062d","453":"670e15c7","511":"7fef5adb"}[chunkId] + ".chunk.js";
};